import React, { ReactElement } from 'react';

import Icon from '@ant-design/icons';
import './style.less';

type Props = {
  icon: ReactElement;
  size?: number;
  onClick?: () => void;
};

const AntdFeatherIcon: React.FC<Props> = ({ icon, size = 24, ...props }) => {
  const fIcon = React.cloneElement(icon, { size });

  return (
    <Icon
      component={() => fIcon}
      className="antd-feather-icon-wrapper"
      {...props}
    />
  );
};

export default AntdFeatherIcon;
